import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FunmiyoBook from "./FunmiyoBook";
import "./styles/funmiyo.css";

/**
 * Public marketing landing page (ported from funmiyo-web).
 * Login CTA goes to /login — the existing portal Auth page.
 */
const LandingPage = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const hash = window.location.hash;
		const searchParams = new URLSearchParams(window.location.search);
		const hasRecoveryHash =
			hash &&
			(hash.includes("type=recovery") ||
				hash.includes("access_token") ||
				hash.includes("#access_token") ||
				hash.includes("refresh_token"));
		const hasRecoveryQuery =
			searchParams.get("type") === "recovery" ||
			searchParams.has("access_token") ||
			searchParams.has("recovery_token");

		if (hasRecoveryHash || hasRecoveryQuery) {
			const redirectPath = hasRecoveryHash
				? `/reset-password${hash}`
				: `/reset-password${window.location.search}${hash || ""}`;
			navigate(redirectPath, { replace: true });
		}
	}, [navigate]);

	return (
		<div className="funmiyo-landing">
			<FunmiyoBook />
		</div>
	);
};
export default LandingPage;
